import React from 'react';
import { PorangeCheckmark } from "@/components/atoms/PorangeCheckmark";
import classNames from 'classnames';
import { Inter } from 'next/font/google';

const inter = Inter({ subsets: ['latin'] });

const Feature = ({ children }) => (
    <div className="flex items-start gap-3 my-3">
        <PorangeCheckmark />
        <div className="text-[#001C3D] text-[15px]">{children}</div>
    </div>
);

const FeaturesSection = ({ variant = "default" }) => {
    return (
        <div className="mt-8">
            <h2 className={classNames(inter.className, {
                "font-bold text-[#001C3D] mb-4": true,
                "text-4xl": variant === "default",
                "text-[21px] uppercase leading-normal": variant === "april",
            })}>
                Find safe gluten-free spots near you
            </h2>
            <div className="flex flex-col">
                <Feature>
                    Access <strong>272K+ verified</strong> safe spots
                </Feature>
                <Feature>
                    vetted <strong>up-to-date</strong> place info
                </Feature>
                <Feature>
                    Find places with <strong>dedicated facilities</strong>
                </Feature>
                <Feature>
                    50+ <strong>filters and safety criterias</strong>
                </Feature>
                <Feature>
                    <strong>up-to-date</strong> information
                </Feature>
            </div>
        </div>
    );
};

export default FeaturesSection; 